//
//
//
//
//
//
//
//
//

import icon from '../icon';
import CheckboxSvg from './primary.svg?inline';
export default {
  name: 'PrimaryCheckboxIcon',
  components: {
    CheckboxSvg,
    icon,
  },
};
